// app_C_OPTIONSInertialDampingDropDown.tsx
import "./index.css"
import {  UIBackground, SiteNavBar} from "./swmmreact"
import { C_OPTIONSInertialDampingDropDown } from "./swmmReact_controls"
import SyntaxHighlighter from 'react-syntax-highlighter'
import { nightOwl as codeStyle } from 'react-syntax-highlighter/dist/esm/styles/hljs'
/* eslint import/no-webpack-loader-syntax: off */
const useDidMount = require('!!raw-loader!./C_OPTIONSInertialDampingDropDown.tsx')

const App = () => {
  return(
    <div >
      <SiteNavBar />
      <div >
        <div style={UIBackground}>
          <h1>Inertial Damping</h1>
          <p>This demo utilizes the 

          <b> <code>OPTIONSInertialDampingDropDown</code></b> component. 
          <b> 'INERTIAL_DAMPING' </b> 

          exists in the 
          <b> OPTIONS </b> 
          section of a swmm model. </p>
          <p>Use this demo to change a preloaded model with the control below. See the code at the bottom of this demo for information on how to create a control like this for your web app.</p>
          <p>For an in-depth explanation of the components of this web app, see the entries for any item in the list below:</p>
          <ul>
            <li>OpenDefaultOutFileHeadless</li>
            <li>OPTIONSInertialDampingDropDown</li>

            <li>handleChange_OPTIONS</li>
            <li>DisplayHead</li>
          </ul>
          <C_OPTIONSInertialDampingDropDown />

          <h2>Demo code to use this component</h2>
          <p>The following code window displays an example way to use this component. It is important to note that this component does not need to use a swmm model.</p>
          <SyntaxHighlighter language='react' style={codeStyle} showLineNumbers={true}>
            {useDidMount.default.toString()}
          </SyntaxHighlighter>
          </div>
        </div>
    </div>
  )
}

export default App;